export const UPDATE_TRAIL = 'dt/trails/UPDATE_TRAIL';

export const updateTrail = (trail = []) => ({
  type: UPDATE_TRAIL,
  trail,
});
